import React, { useState, useEffect, useContext } from 'react';
import { MainContext } from './MainContext';

function RequestHistoryDetails(props) {
   const [selectedRequests, setSelectedRequests] = useState([]);
   const transactionId = props.match.params.transactionId;
   const { requests } = useContext(MainContext);

   const fetchRequest = () => {
      let filteredRequest = requests.filter((item) => item.transactionId === transactionId);
      setSelectedRequests(filteredRequest);
   };

   useEffect(fetchRequest, []);

   if (!requests) return <h1>Request doesn't exists</h1>;

   return (
      <div className='row'>
         <div className='col-6 offset-3'>
            <div>
               {selectedRequests.map((item, index) => (
                  <div className='card mb-1' key={index}>
                     <div className='card-body'>
                        <div className='card-text d-flex flex-row justify-content-between'>
                           <span className='font-weight-bold'>{item.transactionId}</span>
                           <span className='font-italic font-weight-light text-muted'>{item.createdAt}</span>
                        </div>
                        <div className='card-text d-flex flex-column justify-content-between'>
                           <div>
                              <span className='text-uppercase font-weight-normal'>User Input</span>
                              <span className='font-italic'>:{item.userInput}</span>
                           </div>
                           <div>
                              <span className='text-uppercase font-weight-normal'>Reply</span>
                              <span className='font-italic font-weight-lighter'>:{item.responseText}</span>
                           </div>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </div>
   );
}

export default RequestHistoryDetails;
